import React, { useState, useEffect, useRef } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import NavLastLinks from './NavLastLinks';
import '../../index';
import Logo from '../../logos/annex-logo.svg';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Toggle menu state
  const handleClick = () => setIsOpen(!isOpen);

  // Close the menu if clicked outside
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <nav className="navbar relative" role="navigation" aria-label="Main navigation">
      {/* Background for fixed nav bar */}
      <div className="navbar-background"></div>

      <div className="navbar-content relative z-10 flex items-center justify-between px-4 py-3 lg:px-8">
        {/* Logo */}
        <div className="navbar-logo">
          <HashLink smooth to="/#annex" aria-label="Navigate to Annex homepage">
            <img src={Logo} alt="ANNEX Logo" className="h-16" />
          </HashLink>
        </div>

        {/* Centered Links for Large Screens */}
        <div className="hidden lg:flex navbar-links-lg">
          <NavLinks />
        </div>

        {/* Links at the end */}
        <div className="hidden lg:flex">
          <NavLastLinks />
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={handleClick}
          className="lg:hidden navbar-toggle z-20 p-3 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          aria-controls="navbar-mobile-menu"
          style={{ fontSize: '1.8rem', minWidth: '64px', minHeight: '64px' }}
        >
          ☰
        </button>

        {/* Mobile Menu */}
        <div
          id="navbar-mobile-menu"
          ref={menuRef}
          className={`fixed inset-0 bg-white p-6 shadow-lg lg:hidden z-20 transition-transform transform ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
          aria-hidden={!isOpen}
        >
          {/* Back Button */}
          <button
            onClick={() => setIsOpen(false)}
            className="text-gray-700 text-lg font-semibold p-2 mb-4 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            aria-label="Close menu"
          >
            ← Back
          </button>

          {/* Menu Links */}
          <div className="flex flex-col items-center space-y-6 text-lg font-bold">
            <NavLinks />
            <NavLastLinks />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;